import { MessageCircle } from "lucide-react";

export function WhatsAppButton() {
  return (
    <a
      href="mailto:help@vittasathi.com"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-20 right-4 md:bottom-6 md:right-6 z-40 h-14 w-14 rounded-full bg-primary text-primary-foreground flex items-center justify-center shadow-elevated hover:scale-110 transition-transform"
      aria-label="Contact support"
    >
      <MessageCircle className="h-6 w-6" />
    </a>
  );
}
